import React from 'react'
import { Trans } from '@mc/i18n'
import { PrivacyLink, TermsLink } from '../../links'

export const RegularLegal = ({ className = '' }: { className?: string }) => (
  <p className={className}>
    <Trans i18nKey='emailCapture.regular' ns='@mc/legal'>
      <TermsLink />
      <PrivacyLink />
    </Trans>
  </p>
)
